module.exports = __webpack_public_path__ + "media/images/logo_transparent-54506cae74819f11974fce7fb3e1cb6b.svg";